var React = require('react');

function Volume (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#4A4A4A"},[React.createElement("path",{"d":"M6.695 9.366H4v6.307h2.695l5.096 3.97s.936.822.936-.028V5.3c0-.666-.824-.015-.824-.015L6.695 9.366zm8.664-1.159a.678.678 0 0 0-.975 0 .719.719 0 0 0 0 1 4.701 4.701 0 0 1 1.329 3.288 4.712 4.712 0 0 1-1.33 3.296.723.723 0 0 0 0 1.003.678.678 0 0 0 .976 0 6.143 6.143 0 0 0 1.732-4.299 6.124 6.124 0 0 0-1.732-4.288z","key":0}),React.createElement("path",{"d":"M17.488 5.958a.627.627 0 0 0-.933 0 .754.754 0 0 0 0 1.004c1.42 1.53 2.128 3.523 2.13 5.526-.002 2.012-.708 4.019-2.13 5.553a.752.752 0 0 0 0 1.002.64.64 0 0 0 .467.207.638.638 0 0 0 .466-.207C19.162 17.232 20 14.858 20 12.488c0-2.362-.843-4.727-2.512-6.53z","key":1})]));
}

Volume.defaultProps = {"width":"24","height":"24"};

module.exports = Volume;

Volume.default = Volume;
